<nz-form-item [formGroup]="formGroup()">
	<nz-form-label [nzSpan]="7" [nzRequired]="required()">
		{{ label() }}
	</nz-form-label>

	<nz-form-control [nzSpan]="12" nzHasFeedback [nzErrorTip]="errorTpl">
		<label nz-checkbox [formControlName]="controlName()"></label>

		<ng-template #errorTpl let-control>
			@if (control.errors?.['required']) {
				This field is required
			}
			@if (control.errors?.['requiredTrue']) {
				This must be checked
			}
		</ng-template>
	</nz-form-control>
</nz-form-item>
